import { GraphQLError } from "graphql";
import { notify } from "./notify";

export const handleGraphlError = (errors: ReadonlyArray<GraphQLError>) => {
  for (let error of errors) {
    let message = error.message;
    if (message) {
      if (message === "validation") {
        try {
          message = Object.values((error as any).validation)[0][0];
        } catch (ex) {
          message = "Operatiunea nu a putut fi dusă la capat.";
        }
      }

      // if (__DEV__) {
      //   // tslint:disable-next-line:no-console
      //   console.log('Encountered graphql error', errors);
      // }
      notify(message);

      break;
    }
  }
  return true;
};
export const handleNetworkError = (error: Error) => {
  return true;
};



// WEBPACK FOOTER //
// ./src/shared/services/errorHandler.ts